import PropTypes from 'prop-types';
import { useSoyuzExperiment, trans } from '@spotahome/soyuz/client';
import { usePricingContext } from '@spotahome/marketplace-common/src/context/PricingContext';

import { Button } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { useLandlordInformation } from '../../context/LandlordInformationContext';

import { ListingSectionObservable } from '../ListingSection';
import ListingDoubts from '../ListingDoubts';

import { getValuePropositionChips } from './getValuePropositionChips';
import openListingValuePropositionModal from './ListingValuePropositionModal';
import ListingValuePropositionLabels from './ListingValuePropositionLabels';

import './ListingValueProposition.scss';

const ListingValueProposition = ({ listing }) => {
  const { hasNoDeposit } = usePricingContext();
  const { landlordInformation } = useLandlordInformation();
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  const isListingSimplificationBottomVariant =
    useSoyuzExperiment('ListingSimplificationBottom').get('behaviour') ===
    'variant';

  const chipList = getValuePropositionChips({
    listing,
    hasNoDeposit,
    landlordInformation,
    homechecker: listing.runner,
    verificationDate: listing.verificationDate
  });

  if (!isListingSimplificationHeaderVariant) {
    return null;
  }

  return (
    <ListingSectionObservable
      section="listing-value-proposition"
      className={`listing-value-proposition${
        !isListingSimplificationBottomVariant
          ? ' listing-value-proposition--spaced'
          : ''
      }`}
      bordered={false}
    >
      <ListingTitle role="secondary">
        {trans('listing.value.proposition.title')}
      </ListingTitle>
      <ListingValuePropositionLabels
        listing={listing}
        hasNoDeposit={hasNoDeposit}
      />
      <Button
        type="button"
        className="listing-value-proposition__read-more"
        color="link"
        onClick={() =>
          openListingValuePropositionModal({
            chipList,
            fullscreenOnMobile: true
          })
        }
      >
        {trans('listing.value.proposition.see-all')}
      </Button>

      <ListingDoubts
        className="listing-information__listing-doubts"
        cityId={listing.cityId}
        listingId={listing.id}
        countryCode={listing.countryCode}
      />
    </ListingSectionObservable>
  );
};

ListingValueProposition.propTypes = {
  listing: PropTypes.shape({
    propertyFeatures: PropTypes.object,
    instantBooking: PropTypes.object,
    checked: PropTypes.bool,
    bills: PropTypes.object,
    allowsPermanentContract: PropTypes.bool,
    isBestChoice: PropTypes.bool,
    plan: PropTypes.any,
    cityId: PropTypes.string,
    id: PropTypes.string,
    countryCode: PropTypes.string,
    runner: PropTypes.object,
    verificationDate: PropTypes.string
  }).isRequired
};

export default ListingValueProposition;
